import Vue from 'vue'

export default {
  setBookings: (state, value) => {
    state.bookings = value
  },
  setBookingProfiles: (state, value) => {
    state.bookingProfiles = value
  },
  removeBooking: (state, bookingId) => {
    const bookingIndex = state.bookings.findIndex(
      booking => booking.ID === bookingId
    )
    state.bookings.splice(bookingIndex, 1)
  },
  setSelectedBooking: (state, value) => {
    state.selectedBooking = value
  },
  setSelectedBookingValue: (state, data) => {
    Vue.set(state.selectedBooking, data.key, data.value)
  },
  setSelectedBookingProfileId: (state, value) => {
    state.selectedBookingProfileId = value
  },
  setSelectedBookingProfile: (state, value) => {
    state.selectedBookingProfile = value
  },
  addBooking: (state, value) => {
    const exists = state.bookings.some(booking => {
      return booking.ID === value.ID
    })
    if (!exists) {
      state.bookings.unshift(value)
    }
  },
  setBookingInBookingsArray: (state, payload) => {
    if (state.bookings && state.bookings.length > 0) {
      const existingBooking = state.bookings.find(booking => {
        return booking.ID === payload.ID
      })
      Object.assign(existingBooking, payload)
    }
  },
  updateBookingEndTime: (state, { ID, EndTime }) => {
    const existingBooking = state.bookings.find(booking => booking.ID === ID)
    if (existingBooking) {
      existingBooking.EndTime = EndTime
    }
  },
  setCurrentPageNumber: (state, value) => {
    state.currentPageNumber = value
  },
  setPageSize: (state, value) => {
    state.pageSize = value
  },
  setNextAvailablePage: (state, value) => {
    state.nextAvailablePage = value
  }
}
